<template>
  <div class="wrapper">
    <div class="header-search">
      <el-form ref="form" inline :model="searchData" label-width="">
        <el-form-item label="页面">
          <el-select
            v-model="searchData.pageCode"
            placeholder="请选择"
            size="small"
          >
            <el-option
              v-for="item in pageList"
              :key="item.value"
              :label="item.name"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label=" ">
          <el-button type="primary" size="small" @click="getList"
            >搜索</el-button
          >
          <el-button type="info" size="small" @click="reset">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
    <el-divider></el-divider>
    <el-button
      v-checkbtn="isShowBtn(AUTH_BTN.operation_ad_add)"
      style="margin-bottom: 20px"
      type="primary"
      size="small"
      @click="showAddOrEdit=true;rowId=null"
      >新增
    </el-button>
    <tp-table
      :isNeedSerialNumber="true"
      :tableData="list"
      :columns="columns"
      :totalNum="total"
      :current-page.sync="currentPage"
      :pageSize.sync="pageSize"
    />
    <!-- 跳转配置 -->
    <AdLinkConfig ref="page"
      v-if="show"
      :rowId="rowId"
      :show="show"
      @closeDialog="closeDialogFun"
    ></AdLinkConfig>
    <!-- 新增&编辑 -->
    <AddOrEdit
      v-if="showAddOrEdit"
      :rowId="rowId"
      :showAddOrEdit="showAddOrEdit"
      @closeDialog="closeDialogFun"
    />
  </div>
</template>

<script>
import { authBtnMixin } from "@/mixins/authBtnMixin";
import { getListAPI, changeStatusAPI  , deleteOprtAdAPI } from "./api";
import AdLinkConfig from "./link-config.vue";
import AddOrEdit from "./add-edit";

const columns = [
  {
    label: "页面",
    prop: "pageCodeName",
    minWidth: "100",
    customRender(h, row) {
      return <p>{row["pageCodeName"]}</p>;
    },
  },
  {
    label: "图片",
    prop: "imageUrl",
    minWidth: "160",
    customRender(h, row) {
      return (
        <el-image
          src={row["imageUrl"]}
          fit="contain"
          style="width: 60px; height: 60px;"
          preview-src-list={[row["imageUrl"]]}
        ></el-image>
      );
    },
  },
  {
    label: "权重",
    prop: "weight",
    minWidth: "100",
    customRender(h, row) {
      return <p>{row["weight"]}</p>;
    },
  },
  {
    label: "备注",
    prop: "remark",
    minWidth: "120",
    customRender(h, row) {
      return <p>{row["remark"]}</p>;
    },
  },
  {
    label: "创建时间",
    prop: "createTime",
    minWidth: "150",
    customRender(h, row) {
      return <p>{row["createTime"]}</p>;
    },
  },
  {
    label: "状态",
    prop: "status",
    minWidth: "100",
    customRender(h, row) {
      return (
        <div>
          <el-switch
            disabled={!this.isShowBtn(this.AUTH_BTN.operation_ad_status)}
            class="switch"
            onChange={() => this.changeStatus(row)}
            v-model={row["status"]}
            active-value={true}
            inactive-value={false}
            active-text="启用"
            inactive-text="禁用"
          ></el-switch>
        </div>
      );
    },
  },
  {
    label: "操作",
    minWidth: "140",
    align: "center",
    fixed: "right",
    customRender(h, row) {
      return (
        <div>
          <el-link
            style="margin-right:10px;"
            disabled={!this.isShowBtn(this.AUTH_BTN.operation_ad_edit) || row["status"]}
            underline={false}
            type="primary"
            onClick={() => {
              this.showAddOrEdit = true;
              this.rowId = row["id"];
            }}
          >
            编辑
          </el-link>

          <el-link
            style="margin-right:10px;"
            disabled={!this.isShowBtn(this.AUTH_BTN.operation_ad_link_config)}
            underline={false}
            type="primary"
            onClick={() => {
              this.show = true;
              this.rowId = row['id'];
            }}
          >
            跳转配置
          </el-link>

          <el-link
            disabled={!this.isShowBtn(this.AUTH_BTN.operation_ad_del) || row["status"]}
            style="margin-right:10px;"
            underline={false}
            type="danger"
            onClick={() => this.handleDel(row)}
          >
            删除
          </el-link>
        </div>
      );
    },
  },
];
export default {
  name: "OprtAdList",
  mixins: [authBtnMixin],
  components: {
    AdLinkConfig,
    AddOrEdit
  },
  data() {
    return {
      columns,
      currentPage: 1,
      pageSize: 10,
      total: 0,
      list: [],
      searchData: {
        pageCode: "",
      },
      pageList: [
        {
          name: "首页",
          value: "home",
        },
        {
          name: "我的",
          value: "mine",
        },
      ],
      rowId: null,
      showAddOrEdit: false,
      show: false,
    };
  },

  provide() {
    return {
      context: this,
    };
  },
  watch: {
    currentPage() {
      this.getList();
    },
    pageSize() {
      this.getList();
    },
  },
  mounted() {
    this.getList();
  },

  methods: {
    async getList() {
      const { pageCode } = this.searchData;
      let params = {
        pageCode,
        page: this.currentPage,
        pageSize: this.pageSize,
      };
      const res = await getListAPI(params);
      this.list = res.list || [];
      this.total = res.total || 0;
    },
    // 删除
    handleDel({ id }) {
      this.$confirm("确定要删除该广告吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          deleteOprtAdAPI(id).then(() => {
            this.getList();
            this.$message({ type: "success", message: "操作成功!",
            })
          })
        })
        .catch(() => {})
    },
    // 启用/禁用
    changeStatus(row) {
      let { id, status } = row;
      let data = { id, status };
      let confirmDesc = status ? "启用" : "禁用";

      this.$confirm(`此操作将${confirmDesc}该广告, 是否继续?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          row.status = status;
          changeStatusAPI(data).then(() => {
            this.getList();
            this.$message.success("操作成功");
          });
        })
        .catch(() => {
          row.status = !status;
        });
    },

    reset() {
      Object.assign(this._data.searchData, this.$options.data().searchData);
      this.getList();
    },
    // 关闭弹框
    closeDialogFun(flag) {
      this.showAddOrEdit = false;
      this.show = false;
      if (flag) {
        this.getList();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.wrapper /deep/ {
  width: 100%;
  .el-divider--horizontal {
    margin: 0 0 20px;
  }

  .el-form {
    .el-form-item {
      margin-right: 35px;
    }
  }
  .tp-table {
    .el-table__fixed-right {
      height: 100% !important;
    }
  }
  .el-drawer {
    .el-drawer__header {
      font-size: 18px;
      font-weight: 600;
    }
    .goods-box {
      padding: 0 20px;
    }
  }
}
</style>
<style lang="scss" scoped>
.wrapper /deep/ {
  .el-dialog__body {
    padding: 20px 20px 50px 20px;
  }
  /* switch按钮样式 */
  .switch .el-switch__label {
    position: absolute;
    display: none;
    color: #fff !important;
  }

  /*打开时文字位置设置*/
  .switch .el-switch__label--right {
    z-index: 1;
  }

  /* 调整打开时文字的显示位子 */
  .switch .el-switch__label--right span {
    margin-left: 5px;
    margin-right: 10px;
  }

  /*关闭时文字位置设置*/
  .switch .el-switch__label--left {
    z-index: 1;
  }

  /* 调整关闭时文字的显示位子 */
  .switch .el-switch__label--left span {
    margin-left: 20px;
  }

  /*显示文字*/
  .switch .el-switch__label.is-active {
    display: block;
  }

  /* 调整按钮的宽度 */
  .switch.el-switch .el-switch__core,
  .el-switch .el-switch__label {
    width: 55px !important;
    margin: 0;
  }
}
</style>
